import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { columnMultiSelect, columnSelect, hasColumn } from '@/constants/fields';
import MultiSelectCell from './MultiSelectCell';
import SingleSelectCell from './SingleSelectCell';

const SelectableRow = ({
  children,
  className,
  columns = [],
  disabled,
  error,
  label,
  onClick,
  positive,
  selectable,
  selected,
  warning,
}) => {
  const onSelectClick = (event) => {
    event.stopPropagation();
    onClick(event);
  };

  return (
    <Table.Row
      className={clsx('aridhia-selectable-row', className, selectable && !disabled && onClick ? 'pointer' : undefined)}
      verticalAlign="top"
      active={selected && (selectable || hasColumn(columns, [columnMultiSelect, columnSelect]))}
      disabled={disabled}
      positive={positive}
      error={error}
      warning={warning}
      onClick={selectable ? onClick : undefined}
    >
      {hasColumn(columns, columnMultiSelect) && (
        <MultiSelectCell
          label={label}
          onClick={onClick && !disabled ? onSelectClick : undefined}
          checked={selected}
          disabled={disabled}
        />
      )}
      {hasColumn(columns, columnSelect) && !hasColumn(columns, columnMultiSelect) && (
        <SingleSelectCell
          label={label}
          onClick={onClick && !disabled ? onSelectClick : undefined}
          checked={selected}
          disabled={disabled}
        />
      )}
      {children}
    </Table.Row>
  );
};

export default SelectableRow;
